import { Component } from '@angular/core';
import { Headers } from '@angular/http';

/**
 * Generated class for the SupportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 /*@IonicPage()*/
 @Component({
 	selector: 'PageNotFoundComponent',
 	template: ''
 })
 export class SharedComponent {

 	public baseUrl = "https://customerfeedrate.com/api/"; //hostingr vinay
 	//public baseUrl = "http://localhost/getfeedback/index.php/";
 	//public baseUrl="http://thecoderway.com/getfeedback/"; //pavan
    //public baseUrl = "http://103.83.81.106/~thecode1/getfeedback/index.php/";
 	public messages = {
 		InvalidLogin : 'The email address or password you entered is incorrect.',
 		DataSavedSuccess : 'Changes saved successfuly.',
 		Thankyou: 'Thank you for taking the time to provide us with your feedback.',
 		ServerError : 'Server inconvenience issue there.',
 		InvalidEmail : 'Email address does not exists.',
 		NetworkNotFoundTitle : 'No Internet',
 		NetworkNotFoundMessage : 'Please check your network connection.',

 	}

 	public header =  new Headers({
        //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' ,
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Authorization': 'Basic YWRtaW46OUVBQkI0RTFCRTU4RDE4RkYxMkM3RDU4Mjc5NjE='

    });


    public pricing={
    	plan1:'feedratesubstier1_11111',
    	plan2:'feedratesubstier2_11111'
    }

 	/*constructor() {
 	}*/

  /*ionViewDidLoad() {
    console.log('ionViewDidLoad SupportPage');
}*/

}



// WEBPACK FOOTER //
// ./src/shared/shared.ts